export const ticketing = {
  namespaced: true,
  state: {
    storeDivisions: null,
    storeStartDateOfUse: null,
    storeSelectedStationCode: null,
    storePaymentMethod: null,
  },
  getters: {
    storeDivisions(state) {
      return state.storeDivisions;
    },
    storeStartDateOfUse(state) {
      return state.storeStartDateOfUse;
    },
    storeSelectedStationCode(state) {
      return state.storeSelectedStationCode;
    },
    storePaymentMethod(state) {
      return state.storePaymentMethod;
    },
  },
  mutations: {
    resetStoreDivisions(state) {
      state.storeDivisions = null;
    },
    setStoreDivisions(state, divisions) {
      state.storeDivisions = divisions;
    },
    setStoreStartDateOfUse(state, startDateOfUse) {
      state.storeStartDateOfUse = startDateOfUse;
    },
    setStoreSelectedStationCode(state, storeSelectedStationCode) {
      state.storeSelectedStationCode = storeSelectedStationCode;
    },
    setStorePaymentMethod(state, paymentMethod) {
      state.storePaymentMethod = paymentMethod;
    },
  },
};
